import React, { useState } from 'react';
import {
  Div, colors, Figure, weight,
} from 'globalStyle';
import { TextLight } from 'components/Texts';
import { formatNumber } from 'util/formatNumber';
import { Box } from '@material-ui/core';
import { Hollow } from 'components/Buttons';
import Skeleton from 'react-loading-skeleton';
import { Recharge } from 'Layout/components/Menu/components/AvailableMoney/Recharge';
import { PayInterbank } from 'Layout/components/Menu/components/AvailableMoney/PayInterbank';
import RegisterChecker from 'Layout/components/Navbar/components/Register/components/RegisterChecker';
import { useDispatch, useSelector } from 'react-redux';
import { closePopUp, openPopUp } from 'store/popup';
import { useWallet, useUser } from 'hooks';
import refreshBalance from 'assets/icons/refreshBalance.svg';
import eye from 'assets/icons/eye-white.svg';
import noEye from 'assets/icons/no-eye-white.svg';
import { useLocation as useLoc } from 'hooks/useLocation';
import { RechargeStatus } from './AvailableMoney/RechargeStatus';

export default function BalanceMobile() {
  const [isDrop, setDrop] = useState(false);
  const [modalRechange, setModalRechange] = useState(false);
  const { location } = useLoc();
  const { user } = useUser();
  const { defaultWallet, fetch, isLoadingWallet } = useWallet({
    useCache: () => location
      && location.current.includes('/perfil')
      && location.previous.includes('/perfil'),
  });

  const isUserVip = user.info?.userType === 'VIP_INVESTOR' || user.info?.userType === 'VIP_COMPANY';

  const totalAmount = (defaultWallet?.displayValue || 0)
    + (defaultWallet?.unconfirmedAvailableAmount || 0);

  const handelDrop = () => {
    setDrop(!isDrop);
  };
  const dispatch = useDispatch();
  const isOpen = useSelector((store) => store.popup.isOpen);
  const handleClose = () => dispatch(closePopUp());

  const icon = isDrop ? eye : noEye;

  const handleInterbank = () => {
    dispatch(openPopUp({ type: 'interbank' }));
  };

  if (isLoadingWallet) {
    return <Skeleton height="50px" style={{ marginBottom: '20px' }} />;
  }

  return (
    <RegisterChecker check={isOpen} onClose={handleClose}>
      <Box
        p={isDrop ? '15px 20px' : '0 20px'}
        bgcolor={colors.primary}
        display="flex"
        flexDirection="column"
        justifyContent={isDrop ? 'space-between' : 'center'}
        borderRadius="15px"
        margin="25px 0"
        height={isDrop ? '170px' : '45px'}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{
            borderBottom: isDrop && `1px solid ${colors.WHITE}`,
            paddingBottom: isDrop && '7px',
          }}
        >
          <TextLight size={14} color={colors.WHITE} weight={weight.BOLD} align="start">
            Saldo
          </TextLight>
          <Div isFlex width="65px" justify="space-between">
            <Figure
              style={{ width: '20px', height: '20px', cursor: 'pointer' }}
              onClick={() => {
                fetch();
              }}
            >
              <img src={refreshBalance} alt="Refrescar el saldo" />
            </Figure>
            <Figure
              style={{ width: '23px', height: '23px', cursor: 'pointer' }}
              onClick={() => {
                handelDrop();
              }}
            >
              <img src={icon} alt="Ver saldo" />
            </Figure>
          </Div>
        </Box>
        {isDrop && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TextLight size={12} color={colors.WHITE} width="auto">
                Disponible:
              </TextLight>
              <TextLight size={12} color={colors.WHITE} width="auto">
                {formatNumber(defaultWallet?.displayValue || 0, null, defaultWallet?.iso)}
              </TextLight>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TextLight size={12} color={colors.WHITE} width="auto">
                Por confirmar:
              </TextLight>
              <TextLight size={12} color={colors.WHITE} width="auto">
                {formatNumber(
                  defaultWallet?.unconfirmedAvailableAmount || 0, null, defaultWallet?.iso,
                )}
              </TextLight>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TextLight size={12} color={colors.WHITE} width="auto">
                Total:
              </TextLight>
              <TextLight size={12} color={colors.WHITE} width="auto">
                {formatNumber(totalAmount, null, defaultWallet?.iso)}
              </TextLight>
            </Box>
            {!isUserVip && (
              <Div width="100%" isFlex justify="space-between">
                <Hollow
                  isSubmit
                  onClick={() => {
                    handleInterbank();
                  }}
                  size="12px"
                  onColorType="white"
                  color={colors.WHITE}
                  style={{
                    borderRadius: '20px',
                    width: '100px',
                    height: '35px',
                    padding: 0,
                  }}
                >
                  Retirar
                </Hollow>

                <Hollow
                  isSubmit
                  onColorType="fullWhite"
                  onClick={() => setModalRechange(!modalRechange)}
                  padding="7px 0"
                  size="12px"
                  style={{
                    borderRadius: '20px',
                    width: '100px',
                    height: '35px',
                    padding: 0,
                  }}
                >
                  Recargar
                </Hollow>
              </Div>
            )}
          </>
        )}

        {isOpen && <PayInterbank isOpen={isOpen} onClick={handleClose} />}

        {modalRechange && (
          <Recharge
            isOpen={modalRechange}
            userData={user?.info}
            onClick={() => {
              setModalRechange(false);
            }}
          />
        )}
        <RechargeStatus />
      </Box>
    </RegisterChecker>
  );
}
